<template>
  <div class="playback" :style="animationSpeed">
    <div class="playback__ldr-box" v-if="props.isLoading" :style="`transform: scale(${props.scale})`">
      <LoaderCircle class="playback__ldr" :color="props.color" />
    </div>
    <PlayIcon 
      class="playback__play"
      :style="`transform: scale(${props.scale}); color: ${props.color}`"
      v-else-if="!props.isPlaying"
    />
    <PauseIcon
      class="playback__pause"
      :style="`transform: scale(${props.scale}); color: ${props.color}`"
      v-else
    />
  </div>
</template>

<script setup>
  import { Props } from './props.js';
  import { computed } from 'vue';
  //--------------------------
  import PauseIcon from '../../svg/PauseIcon.vue'
  import PlayIcon from '../../svg/PlayIcon.vue'
  import { LoaderCircle } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //--------------------------
  const props = defineProps(Props());
  //Увеличение скорости проигрывания анимации, в зависимости от скорости проигрывания аудио
  const animationSpeed = computed(() => {
    return {'--animation-play-duration': `${1.5 / (props.speed - 0.2)}s`};
  });
</script>

<style scoped lang="scss">
  @import './styles';
</style>

